export default __webpack_public_path__ + "static/media/layered-waves-haikei-3.a4bcc753.svg";